module.exports = require("@prisma/client/runtime/query_compiler_fast_bg.postgresql.wasm-base64.mjs");